import type { Skill } from '../skillsData';

export const cryptoskillWalletsData: Skill[] = [
  {
    id: 'agentic-wallet-bundler',
    name: 'agentic-wallet-bundler',
    author: 'Agentic Wallet Labs',
    authorHandle: '@agentic_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'AI-powered wallet bundling for gasless transactions. Batch user operations, optimize gas costs, and abstract account complexity for seamless UX.',
    downloads: 14200,
    stars: 1056,
    installCommand: '> install the agentic-wallet-bundler skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/agentic-wallet-bundler',
    usageExample: '> bundle transactions\n> optimize gas\n> manage userOps',
    detailedDescription: 'Agentic Wallet Bundler provides advanced transaction batching for ERC-4337 smart accounts. Bundle multiple user operations into a single transaction to dramatically reduce gas costs, optimize operation ordering for maximum efficiency, and abstract away account complexity so users enjoy a seamless gasless experience across dApps.',
  },
  {
    id: 'agentic-wallet',
    name: 'agentic-wallet',
    author: 'Agentic Wallet Labs',
    authorHandle: '@agentic_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Autonomous wallet with AI-driven transaction management. Intent-based execution, automated security checks, and cross-chain portfolio rebalancing.',
    downloads: 18900,
    stars: 1423,
    installCommand: '> install the agentic-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/agentic-wallet',
    usageExample: '> execute intent\n> security scan\n> rebalance portfolio',
    detailedDescription: 'Agentic Wallet is an AI-driven autonomous crypto wallet. Execute transactions based on natural language intents rather than complex transaction data, run automated security checks that flag suspicious addresses and contracts before signing, and perform cross-chain portfolio rebalancing to maintain your desired asset allocation across multiple networks.',
  },
  {
    id: 'base-smart-wallet-agent',
    name: 'base-smart-wallet-agent',
    author: 'Base Smart Wallet',
    authorHandle: '@base_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Smart wallet agent for Base network. ERC-4337 account abstraction, gasless transactions, and social recovery on Coinbase Layer 2.',
    downloads: 15600,
    stars: 1167,
    installCommand: '> install the base-smart-wallet-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/base-smart-wallet-agent',
    usageExample: '> deploy smart account\n> send gasless tx\n> setup recovery',
    detailedDescription: 'Base Smart Wallet Agent provides ERC-4337 account abstraction on the Base network. Deploy smart contract accounts with programmable logic, execute gasless transactions sponsored by paymasters, and configure social recovery mechanisms so you never lose access to your funds on Coinbase Layer 2.',
  },
  {
    id: 'bassbot-base',
    name: 'bassbot-base',
    author: 'BassBot',
    authorHandle: '@bassbot',
    tag: 'Skill',
    category: 'wallets',
    description: 'BassBot wallet integration for Base chain. Automated payments, recurring transfers, and smart contract wallet management on Base L2.',
    downloads: 7800,
    stars: 587,
    installCommand: '> install the bassbot-base skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/bassbot-base',
    usageExample: '> setup auto payments\n> schedule transfers\n> manage wallet',
    detailedDescription: 'BassBot Base brings automated wallet operations to the Base network. Set up recurring payments and subscriptions with programmable schedules, schedule future transfers for optimal timing, and manage smart contract wallet configurations including permissions and spending limits on Coinbase Layer 2.',
  },
  {
    id: 'bassbot',
    name: 'bassbot',
    author: 'BassBot',
    authorHandle: '@bassbot',
    tag: 'Skill',
    category: 'wallets',
    description: 'BassBot multi-chain wallet automation. Cross-chain payments, automated yield harvesting, and smart savings across EVM networks.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the bassbot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/bassbot',
    usageExample: '> cross-chain payment\n> harvest yield\n> smart savings',
    detailedDescription: 'BassBot provides multi-chain wallet automation across EVM networks. Execute cross-chain payments with automatic bridge routing and fee optimization, harvest yield from DeFi protocols on a scheduled basis, and configure smart savings rules that automatically allocate incoming funds to yield-generating strategies based on your preferences.',
  },
  {
    id: 'bitget-official-wallet',
    name: 'bitget-official-wallet',
    author: 'Bitget Wallet',
    authorHandle: '@bitget_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Official Bitget Wallet integration. Multi-chain asset management, DApp browser, and integrated swap functionality for Bitget exchange users.',
    downloads: 23400,
    stars: 1756,
    installCommand: '> install the bitget-official-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/bitget-official-wallet',
    usageExample: '> view portfolio\n> browse DApps\n> swap tokens',
    detailedDescription: 'Bitget Official Wallet provides deep integration with the Bitget ecosystem. Manage multi-chain assets with real-time price tracking and portfolio analytics, browse and interact with decentralized applications through the built-in DApp browser, and execute token swaps with competitive rates directly connected to Bitget exchange liquidity.',
  },
  {
    id: 'bitget-wallet-official-skill',
    name: 'bitget-wallet-official-skill',
    author: 'Bitget Wallet',
    authorHandle: '@bitget_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Bitget Wallet official skill for AI agents. Wallet querying, transaction signing, and portfolio management through agent interfaces.',
    downloads: 17800,
    stars: 1334,
    installCommand: '> install the bitget-wallet-official-skill skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/bitget-wallet-official-skill',
    usageExample: '> query wallet\n> sign transaction\n> manage portfolio',
    detailedDescription: 'Bitget Wallet Official Skill enables AI agents to interact with Bitget Wallet programmatically. Query wallet balances, transaction history, and token prices through structured APIs, sign and broadcast transactions with configurable confirmation workflows, and manage portfolio allocations with automated rebalancing and risk controls.',
  },
  {
    id: 'bitget-wallet',
    name: 'bitget-wallet',
    author: 'Bitget Wallet',
    authorHandle: '@bitget_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Bitget Wallet core integration. Secure multi-chain wallet with MPC security, social recovery, and native DeFi integrations.',
    downloads: 26700,
    stars: 1987,
    installCommand: '> install the bitget-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/bitget-wallet',
    usageExample: '> create wallet\n> add chain\n> connect DApp',
    detailedDescription: 'Bitget Wallet is a secure multi-chain crypto wallet with advanced features. Create and manage wallets protected by MPC (Multi-Party Computation) security that eliminates single points of failure, configure social recovery with trusted guardians, and access native DeFi integrations for swapping, staking, and yield farming across 100+ chains.',
  },
  {
    id: 'circle-wallet-agent',
    name: 'circle-wallet-agent',
    author: 'Circle',
    authorHandle: '@circle',
    tag: 'Skill',
    category: 'wallets',
    description: 'Circle Programmable Wallets agent integration. USDC-centric wallet creation, programmable transactions, and compliance-ready custody for developers.',
    downloads: 12300,
    stars: 923,
    installCommand: '> install the circle-wallet-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/circle-wallet-agent',
    usageExample: '> create wallet\n> program transaction\n> manage custody',
    detailedDescription: 'Circle Wallet Agent provides programmatic access to Circle Programmable Wallets. Create wallets with built-in USDC support and programmable transaction logic, configure compliance-ready custody solutions with policy controls and audit trails, and manage developer-facing wallet infrastructure for embedding crypto payments in applications.',
  },
  {
    id: 'cobo-tss',
    name: 'cobo-tss',
    author: 'Cobo',
    authorHandle: '@cobo_global',
    tag: 'Skill',
    category: 'wallets',
    description: 'Cobo Threshold Signature Scheme (TSS) wallet. Multi-party computation custody, institutional-grade security, and programmable wallet policies.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the cobo-tss skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/cobo-tss',
    usageExample: '> setup TSS\n> create policy\n> execute transaction',
    detailedDescription: 'Cobo TSS provides institutional-grade wallet security through threshold signature schemes. Implement multi-party computation where key shares are distributed across multiple devices and parties, configure programmable wallet policies with spending limits and approval workflows, and execute transactions that require configurable threshold signatures for maximum security.',
  },
  {
    id: 'coinbase-developer-platform-mcp',
    name: 'coinbase-developer-platform-mcp',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase Developer Platform MCP wallet integration. Onchain kit tools, smart wallet APIs, and Base network development utilities.',
    downloads: 19800,
    stars: 1489,
    installCommand: '> install the coinbase-developer-platform-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-developer-platform-mcp',
    usageExample: '> deploy smart wallet\n> use onchain kit\n> build on Base',
    detailedDescription: 'Coinbase Developer Platform MCP provides wallet-focused tools for developers building on Base and Ethereum. Deploy smart wallets with passkey authentication and paymaster support, leverage Onchain Kit components for building wallet-connected UIs, and access Base network development utilities for testing, debugging, and deploying wallet-integrated applications.',
  },
  {
    id: 'coinbase-official-authenticate-wallet',
    name: 'coinbase-official-authenticate-wallet',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase official wallet authentication. Passkey login, biometric verification, and seamless Coinbase Wallet SDK integration for dApps.',
    downloads: 24500,
    stars: 1834,
    installCommand: '> install the coinbase-official-authenticate-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-authenticate-wallet',
    usageExample: '> authenticate user\n> verify passkey\n> connect wallet',
    detailedDescription: 'Coinbase Official Authenticate Wallet provides enterprise-grade authentication for dApps. Implement passkey-based login that eliminates password fatigue, verify users with biometric authentication including Face ID and fingerprint, and integrate seamlessly with Coinbase Wallet SDK for one-tap connection across mobile and desktop platforms.',
  },
  {
    id: 'coinbase-official-fund',
    name: 'coinbase-official-fund',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase official funding tools. Fiat on-ramp integration, payment method linking, and instant wallet funding for new users.',
    downloads: 21300,
    stars: 1589,
    installCommand: '> install the coinbase-official-fund skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-fund',
    usageExample: '> add payment method\n> fund wallet\n> on-ramp fiat',
    detailedDescription: 'Coinbase Official Fund provides fiat-to-crypto on-ramp capabilities for wallet applications. Integrate bank transfers, card payments, and Apple Pay for instant wallet funding, link multiple payment methods with configurable default preferences, and offer new users a seamless first-time funding experience with guided KYC and instant crypto delivery.',
  },
  {
    id: 'coinbase-official-monetize-service',
    name: 'coinbase-official-monetize-service',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase monetization SDK for wallets. Subscription billing, pay-per-use transactions, and revenue-sharing for wallet-integrated services.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the coinbase-official-monetize-service skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-monetize-service',
    usageExample: '> setup subscription\n> charge per use\n> share revenue',
    detailedDescription: 'Coinbase Official Monetize Service enables revenue generation through wallet integrations. Implement subscription billing models with automatic recurring crypto payments, configure pay-per-use transaction pricing for API and service access, and set up revenue-sharing agreements that distribute fees between service providers and wallet operators transparently on-chain.',
  },
  {
    id: 'coinbase-official-pay-for-service',
    name: 'coinbase-official-pay-for-service',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase pay-for-service integration. One-click payments, service discovery, and wallet-based billing for on-chain services.',
    downloads: 13400,
    stars: 1012,
    installCommand: '> install the coinbase-official-pay-for-service skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-pay-for-service',
    usageExample: '> discover service\n> one-click pay\n> manage billing',
    detailedDescription: 'Coinbase Official Pay for Service simplifies on-chain service payments. Discover vetted on-chain services through the integrated marketplace, execute one-click payments that handle token approvals and swaps automatically, and manage billing history with transparent fee breakdowns and receipt generation for accounting and expense tracking.',
  },
  {
    id: 'coinbase-official-query-onchain-data',
    name: 'coinbase-official-query-onchain-data',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase on-chain data querying for wallets. Balance lookups, transaction history, and token metadata retrieval through official APIs.',
    downloads: 16700,
    stars: 1256,
    installCommand: '> install the coinbase-official-query-onchain-data skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-query-onchain-data',
    usageExample: '> query balance\n> get history\n> fetch metadata',
    detailedDescription: 'Coinbase Official Query Onchain Data provides reliable blockchain data access for wallet applications. Query real-time balances across multiple networks with automatic token discovery, retrieve comprehensive transaction histories with decoded event logs, and fetch token metadata including logos, decimals, and verified contract information through Coinbase official infrastructure.',
  },
  {
    id: 'coinbase-official-search-for-service',
    name: 'coinbase-official-search-for-service',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase service discovery for wallets. Search on-chain services, filter by category, and connect wallet-enabled applications.',
    downloads: 9800,
    stars: 734,
    installCommand: '> install the coinbase-official-search-for-service skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-search-for-service',
    usageExample: '> search services\n> filter category\n> connect app',
    detailedDescription: 'Coinbase Official Search for Service enables wallet-integrated service discovery. Search the on-chain service directory with natural language queries, filter results by category including DeFi, gaming, social, and NFTs, and connect to verified applications with one-tap wallet authentication for immediate access to services.',
  },
  {
    id: 'coinbase-official-send-usdc',
    name: 'coinbase-official-send-usdc',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase USDC transfer optimization. Gasless USDC sends, cross-chain bridging, and instant settlement for dollar-denominated payments.',
    downloads: 28900,
    stars: 2145,
    installCommand: '> install the coinbase-official-send-usdc skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-send-usdc',
    usageExample: '> send USDC\n> bridge cross-chain\n> instant settle',
    detailedDescription: 'Coinbase Official Send USDC provides optimized stablecoin transfer capabilities. Execute gasless USDC sends sponsored by Coinbase paymasters on supported networks, bridge USDC across chains with automatic route optimization for lowest fees and fastest settlement, and enjoy instant finality for dollar-denominated payments with real-time confirmation tracking.',
  },
  {
    id: 'coinbase-official-trade',
    name: 'coinbase-official-trade',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase wallet-integrated trading. Spot swaps, limit orders, and liquidity provision directly from Coinbase Wallet with competitive rates.',
    downloads: 19800,
    stars: 1489,
    installCommand: '> install the coinbase-official-trade skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-trade',
    usageExample: '> spot swap\n> place limit order\n> provide liquidity',
    detailedDescription: 'Coinbase Official Trade brings exchange-grade trading to wallet users. Execute spot swaps with deep liquidity from Coinbase and partner DEXs, place limit orders that execute automatically when price conditions are met, and provide liquidity to earn yield on idle assets — all directly within the Coinbase Wallet interface with transparent fee structures.',
  },
  {
    id: 'coinbase-official-x402',
    name: 'coinbase-official-x402',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinbase x402 payment protocol. HTTP 402 payment integration, micropayments for APIs, and wallet-authenticated resource access.',
    downloads: 6700,
    stars: 512,
    installCommand: '> install the coinbase-official-x402 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinbase-official-x402',
    usageExample: '> setup x402\n> process micropayment\n> authenticate access',
    detailedDescription: 'Coinbase Official x402 implements the HTTP 402 Payment Required protocol for crypto-native payments. Integrate micropayment capabilities into APIs and web services where users pay per request, process sub-cent transactions efficiently using Layer 2 networks, and authenticate resource access with cryptographic wallet signatures instead of traditional API keys.',
  },
  {
    id: 'coinfello',
    name: 'coinfello',
    author: 'Coinfello',
    authorHandle: '@coinfello',
    tag: 'Skill',
    category: 'wallets',
    description: 'Coinfello social wallet. Friends-based transfers, group payments, and social transaction feeds for everyday crypto usage.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the coinfello skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/coinfello',
    usageExample: '> send to friend\n> group payment\n> view feed',
    detailedDescription: 'Coinfello reimagines the wallet as a social experience. Send crypto to friends using usernames instead of addresses, coordinate group payments for shared expenses with automatic split calculations, and browse a social transaction feed that shows activity from your network with privacy controls and optional sharing.',
  },
  {
    id: 'crypto-wallet',
    name: 'crypto-wallet',
    author: 'CryptoWallet Foundation',
    authorHandle: '@crypto_wallet_fdn',
    tag: 'Skill',
    category: 'wallets',
    description: 'Generic crypto wallet toolkit. Address generation, key management, transaction building, and multi-chain support for wallet developers.',
    downloads: 24500,
    stars: 1834,
    installCommand: '> install the crypto-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/crypto-wallet',
    usageExample: '> generate address\n> manage keys\n> build tx',
    detailedDescription: 'Crypto Wallet provides foundational wallet tools for developers building crypto applications. Generate deterministic addresses from seed phrases across multiple chains, implement secure key management with hardware-backed encryption options, and build and sign transactions with support for legacy, EIP-1559, and custom transaction types across EVM and non-EVM networks.',
  },
  {
    id: 'emblem-ai',
    name: 'emblem-ai',
    author: 'Emblem AI',
    authorHandle: '@emblem_ai',
    tag: 'Skill',
    category: 'wallets',
    description: 'Emblem AI wallet intelligence. Portfolio insights, risk scoring, and AI-powered transaction recommendations for smarter asset management.',
    downloads: 10200,
    stars: 767,
    installCommand: '> install the emblem-ai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/emblem-ai',
    usageExample: '> get insights\n> score risk\n> receive recommendations',
    detailedDescription: 'Emblem AI brings artificial intelligence to wallet management. Generate portfolio insights that identify concentration risks and rebalancing opportunities, score transaction risks based on contract analysis and address reputation, and receive AI-powered recommendations for yield opportunities, gas optimization, and security best practices tailored to your holdings.',
  },
  {
    id: 'exo-wallet-agent',
    name: 'exo-wallet-agent',
    author: 'Exo Wallet',
    authorHandle: '@exo_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Exo Wallet AI agent. Conversational wallet management, natural language transactions, and automated portfolio defense strategies.',
    downloads: 7800,
    stars: 587,
    installCommand: '> install the exo-wallet-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/exo-wallet-agent',
    usageExample: '> chat with wallet\n> send by voice\n> defend portfolio',
    detailedDescription: 'Exo Wallet Agent enables conversational interaction with your crypto assets. Manage your wallet through natural language conversations instead of complex CLI commands, execute transactions by describing them in plain English with AI-powered intent parsing, and deploy automated portfolio defense strategies that detect and respond to market volatility and security threats.',
  },
  {
    id: 'exo-wallet',
    name: 'exo-wallet',
    author: 'Exo Wallet',
    authorHandle: '@exo_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Exo multi-chain smart wallet. Modular account architecture, plugin-based features, and developer-friendly wallet customization.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the exo-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/exo-wallet',
    usageExample: '> customize modules\n> install plugin\n> deploy wallet',
    detailedDescription: 'Exo Wallet is a modular multi-chain smart wallet with plugin architecture. Customize wallet functionality by adding or removing modules including social recovery, multi-sig, and spending limits, install community-built plugins that extend wallet capabilities, and deploy customized wallet instances with tailored configurations for different use cases and user personas.',
  },
  {
    id: 'jaw-agent-wallet',
    name: 'jaw-agent-wallet',
    author: 'JAW Wallet',
    authorHandle: '@jaw_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'JAW agent-driven wallet. Intent-based DeFi interactions, automated yield farming, and gas-optimized transaction bundling.',
    downloads: 5600,
    stars: 423,
    installCommand: '> install the jaw-agent-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/jaw-agent-wallet',
    usageExample: '> state intent\n> auto farm yield\n> bundle transactions',
    detailedDescription: 'JAW Agent Wallet simplifies DeFi through intent-based interactions. State your financial goals in natural language and let the agent find optimal execution paths, automate yield farming across multiple protocols with automatic rebalancing and harvest scheduling, and bundle related transactions to minimize gas costs and maximize capital efficiency.',
  },
  {
    id: 'metamask-agent-wallet',
    name: 'metamask-agent-wallet',
    author: 'MetaMask',
    authorHandle: '@metamask',
    tag: 'Skill',
    category: 'wallets',
    description: 'MetaMask agent wallet integration. Snaps-based extensions, institutional APIs, and programmable account controls for MetaMask.',
    downloads: 31200,
    stars: 2345,
    installCommand: '> install the metamask-agent-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/metamask-agent-wallet',
    usageExample: '> install snap\n> use institutional API\n> program account',
    detailedDescription: 'MetaMask Agent Wallet extends the world\'s most popular crypto wallet with agent capabilities. Install and manage Snaps that add new blockchain networks and features, access institutional-grade APIs for multi-account management and compliance reporting, and implement programmable account controls with spending limits and multi-signature requirements for institutional deployments.',
  },
  {
    id: 'metamask-official-gator-cli',
    name: 'metamask-official-gator-cli',
    author: 'MetaMask',
    authorHandle: '@metamask',
    tag: 'Skill',
    category: 'wallets',
    description: 'MetaMask Gator CLI. Command-line wallet management, transaction scripting, and developer tools for MetaMask power users.',
    downloads: 14500,
    stars: 1089,
    installCommand: '> install the metamask-official-gator-cli skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/metamask-official-gator-cli',
    usageExample: '> manage wallet\n> script transaction\n> use dev tools',
    detailedDescription: 'MetaMask Official Gator CLI provides command-line access to MetaMask functionality. Manage wallets, accounts, and permissions through structured terminal commands, script complex transaction sequences for automated workflows and testing, and access developer tools for debugging, network switching, and contract interaction directly from the command line.',
  },
  {
    id: 'metamask-official-smart-accounts-kit',
    name: 'metamask-official-smart-accounts-kit',
    author: 'MetaMask',
    authorHandle: '@metamask',
    tag: 'Skill',
    category: 'wallets',
    description: 'MetaMask smart accounts SDK. ERC-4337 account abstraction, passkey authentication, and modular account plugins for developers.',
    downloads: 18900,
    stars: 1423,
    installCommand: '> install the metamask-official-smart-accounts-kit skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/metamask-official-smart-accounts-kit',
    usageExample: '> deploy smart account\n> setup passkey\n> add plugin',
    detailedDescription: 'MetaMask Official Smart Accounts Kit enables developers to build next-generation wallets with account abstraction. Deploy ERC-4337 smart contract accounts with programmable logic and social recovery, implement passkey authentication for biometric login without seed phrases, and add modular plugins that extend account capabilities including session keys and automated payments.',
  },
  {
    id: 'metamask-wallet',
    name: 'metamask-wallet',
    author: 'MetaMask',
    authorHandle: '@metamask',
    tag: 'Skill',
    category: 'wallets',
    description: 'MetaMask wallet core integration. Browser extension APIs, mobile SDK, and hardware wallet support for the leading Ethereum wallet.',
    downloads: 34500,
    stars: 2589,
    installCommand: '> install the metamask-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/metamask-wallet',
    usageExample: '> connect browser\n> use mobile SDK\n> link hardware',
    detailedDescription: 'MetaMask Wallet provides comprehensive integration with the leading Ethereum wallet. Connect to the browser extension for desktop dApp interactions with event-driven APIs, use the mobile SDK for native iOS and Android wallet integration, and support hardware wallets including Ledger and Trezor for air-gapped key storage and maximum security.',
  },
  {
    id: 'metamask',
    name: 'metamask',
    author: 'MetaMask',
    authorHandle: '@metamask',
    tag: 'Skill',
    category: 'wallets',
    description: 'MetaMask protocol integration. Ethereum provider APIs, network management, and transaction injection for dApp connectivity.',
    downloads: 37800,
    stars: 2834,
    installCommand: '> install the metamask skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/metamask',
    usageExample: '> inject provider\n> manage networks\n> send transaction',
    detailedDescription: 'MetaMask is the foundational protocol integration for Ethereum dApps. Inject the Ethereum provider API for seamless wallet detection and connection, manage multiple networks with custom RPC endpoints and chain IDs, and handle transaction injection with automatic gas estimation, nonce management, and user confirmation flows for reliable dApp interactions.',
  },
  {
    id: 'mpc-payments',
    name: 'mpc-payments',
    author: 'MPC Payments',
    authorHandle: '@mpc_payments',
    tag: 'Skill',
    category: 'wallets',
    description: 'MPC-based payment infrastructure. Threshold signature payments, institutional custody transfers, and secure multi-party transactions.',
    downloads: 6700,
    stars: 512,
    installCommand: '> install the mpc-payments skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/mpc-payments',
    usageExample: '> setup threshold\n> execute payment\n> manage custody',
    detailedDescription: 'MPC Payments provides enterprise payment infrastructure using multi-party computation. Execute threshold signature payments that require multiple parties to authorize transactions, implement institutional custody transfers with configurable approval workflows and compliance checks, and manage secure multi-party transactions across geographically distributed key shares for maximum resilience.',
  },
  {
    id: 'okx-agentic-wallet',
    name: 'okx-agentic-wallet',
    author: 'OKX',
    authorHandle: '@okx',
    tag: 'Skill',
    category: 'wallets',
    description: 'OKX agentic wallet. AI-assisted trading, automated yield strategies, and smart portfolio management within OKX Wallet ecosystem.',
    downloads: 15600,
    stars: 1167,
    installCommand: '> install the okx-agentic-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/okx-agentic-wallet',
    usageExample: '> ai trade assist\n> auto yield\n> smart portfolio',
    detailedDescription: 'OKX Agentic Wallet combines AI with OKX Wallet capabilities. Receive AI-assisted trading suggestions with risk analysis and market context, deploy automated yield strategies that move funds between protocols based on real-time APY comparisons, and manage your portfolio with smart rebalancing that maintains target allocations while minimizing tax implications and gas costs.',
  },
  {
    id: 'portkey-official-cb-agent-skills',
    name: 'portkey-official-cb-agent-skills',
    author: 'Portkey',
    authorHandle: '@portkey_ai',
    tag: 'Skill',
    category: 'wallets',
    description: 'Portkey Coinbase agent skills. LLM wallet operations, AI transaction approval, and conversational portfolio management for Coinbase Wallet.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the portkey-official-cb-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/portkey-official-cb-agent-skills',
    usageExample: '> llm wallet op\n> ai approve tx\n> chat portfolio',
    detailedDescription: 'Portkey Official CB Agent Skills bridges large language models with Coinbase Wallet operations. Execute wallet operations through natural language commands parsed by LLMs, implement AI-powered transaction approval workflows that evaluate risk and context before signing, and manage your portfolio through conversational interfaces that explain holdings, performance, and opportunities in plain language.',
  },
  {
    id: 'privy-official-agentic-wallets',
    name: 'privy-official-agentic-wallets',
    author: 'Privy',
    authorHandle: '@privy_io',
    tag: 'Skill',
    category: 'wallets',
    description: 'Privy agentic wallet infrastructure. Embedded wallets, social login, and server-side transaction management for seamless UX.',
    downloads: 13400,
    stars: 1012,
    installCommand: '> install the privy-official-agentic-wallets skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/privy-official-agentic-wallets',
    usageExample: '> embed wallet\n> social login\n> server tx',
    detailedDescription: 'Privy Official Agentic Wallets provides embedded wallet infrastructure for modern applications. Create non-custodial wallets that are embedded directly in your application without browser extensions, enable social login with email, Google, and Twitter for instant onboarding without seed phrases, and manage server-side transactions with secure key handling for automated operations and gasless experiences.',
  },
  {
    id: 'reown-official-skills',
    name: 'reown-official-skills',
    author: 'Reown',
    authorHandle: '@reown',
    tag: 'Skill',
    category: 'wallets',
    description: 'Reown official wallet skills. WalletConnect v3 integration, cross-platform connections, and modular wallet kit for developers.',
    downloads: 17800,
    stars: 1334,
    installCommand: '> install the reown-official-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/reown-official-skills',
    usageExample: '> connect wallet\n> cross platform\n> use wallet kit',
    detailedDescription: 'Reown Official Skills provides the next generation of wallet connection infrastructure. Integrate WalletConnect v3 for seamless mobile and desktop wallet connections, manage cross-platform connections with unified session handling across web, iOS, and Android, and use the modular wallet kit to customize connection flows, chain support, and UI themes for your application.',
  },
  {
    id: 'safe-agent-kit',
    name: 'safe-agent-kit',
    author: 'Safe',
    authorHandle: '@safe',
    tag: 'Skill',
    category: 'wallets',
    description: 'Safe agent toolkit for multi-sig wallets. Transaction batching, role-based permissions, and automated treasury management for DAOs.',
    downloads: 15600,
    stars: 1167,
    installCommand: '> install the safe-agent-kit skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/safe-agent-kit',
    usageExample: '> batch transactions\n> set permissions\n> manage treasury',
    detailedDescription: 'Safe Agent Kit provides programmatic access to the industry-leading multi-signature wallet. Batch multiple transactions into a single Safe proposal for gas efficiency and atomic execution, configure role-based permissions with granular access controls for different team members, and automate treasury management with scheduled payments, vesting distributions, and spending limit enforcement for DAO operations.',
  },
  {
    id: 'safe-mcp-server',
    name: 'safe-mcp-server',
    author: 'Safe',
    authorHandle: '@safe',
    tag: 'Skill',
    category: 'wallets',
    description: 'Safe MCP server for AI agent integration. Multi-sig wallet control, transaction simulation, and agent-safe interaction protocols.',
    downloads: 8900,
    stars: 678,
    installCommand: '> install the safe-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/safe-mcp-server',
    usageExample: '> agent control\n> simulate tx\n> interact safe',
    detailedDescription: 'Safe MCP Server enables AI agents to interact with Safe multi-sig wallets through the Model Context Protocol. Grant agents controlled access to wallet operations with configurable permission scopes, simulate transactions before execution to preview outcomes and catch errors, and establish secure interaction protocols that maintain the security guarantees of multi-signature authorization while enabling automation.',
  },
  {
    id: 'trust-wallet-skills',
    name: 'trust-wallet-skills',
    author: 'Trust Wallet',
    authorHandle: '@trustwallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Trust Wallet official skills. Multi-chain asset management, built-in DEX aggregation, and NFT support for the Binance-backed wallet.',
    downloads: 23400,
    stars: 1756,
    installCommand: '> install the trust-wallet-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/trust-wallet-skills',
    usageExample: '> manage assets\n> swap tokens\n> view NFTs',
    detailedDescription: 'Trust Wallet Skills provides comprehensive access to the Binance-backed multi-chain wallet. Manage assets across 70+ blockchains with native token support and price tracking, swap tokens through built-in DEX aggregation that routes trades across multiple liquidity sources for best prices, and view, manage, and trade NFTs with support for major marketplaces and standards across all supported chains.',
  },
  {
    id: 'trustwallet-ensoul',
    name: 'trustwallet-ensoul',
    author: 'Trust Wallet',
    authorHandle: '@trustwallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Trust Wallet ENSoul integration. Decentralized identity, soulbound tokens, and reputation-based wallet features for Web3 natives.',
    downloads: 6700,
    stars: 512,
    installCommand: '> install the trustwallet-ensoul skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/trustwallet-ensoul',
    usageExample: '> manage identity\n> view SBTs\n> check reputation',
    detailedDescription: 'TrustWallet ENSoul integrates decentralized identity features into Trust Wallet. Manage ENS and other naming services for human-readable addresses, view and manage soulbound tokens that represent non-transferable credentials and achievements, and check on-chain reputation scores from verified attestation protocols for trust verification in transactions and interactions.',
  },
  {
    id: 'vincent-agent-wallet',
    name: 'vincent-agent-wallet',
    author: 'Vincent Wallet',
    authorHandle: '@vincent_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Vincent AI agent wallet. Conversational DeFi execution, intent-based swaps, and automated portfolio insights for everyday users.',
    downloads: 5600,
    stars: 423,
    installCommand: '> install the vincent-agent-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/vincent-agent-wallet',
    usageExample: '> chat execute\n> intent swap\n> get insights',
    detailedDescription: 'Vincent Agent Wallet makes DeFi accessible through conversation. Execute complex DeFi operations like swaps, staking, and bridging through natural language chat, perform intent-based swaps where you state what you want and the agent finds the best route, and receive automated portfolio insights that track performance, alert on opportunities, and warn about risks in plain language.',
  },
  {
    id: 'wallet-pilot',
    name: 'wallet-pilot',
    author: 'Wallet Pilot',
    authorHandle: '@wallet_pilot',
    tag: 'Skill',
    category: 'wallets',
    description: 'Wallet Pilot navigation tool. Chain switching, gas estimation, and transaction preview for safer wallet interactions across networks.',
    downloads: 7800,
    stars: 587,
    installCommand: '> install the wallet-pilot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/wallet-pilot',
    usageExample: '> switch chain\n> estimate gas\n> preview tx',
    detailedDescription: 'Wallet Pilot provides navigation and safety tools for multi-chain wallet usage. Switch between chains with automatic network configuration and token bridging suggestions, estimate gas costs across multiple networks with real-time fee oracle data, and preview transactions before signing with decoded contract calls, token transfers, and risk warnings for suspicious operations.',
  },
  {
    id: 'wallet-portfolio-agent',
    name: 'wallet-portfolio-agent',
    author: 'Portfolio Agent Labs',
    authorHandle: '@portfolio_agent',
    tag: 'Skill',
    category: 'wallets',
    description: 'Wallet portfolio management agent. Real-time P&L tracking, risk-adjusted rebalancing, and tax-optimized transaction scheduling.',
    downloads: 11200,
    stars: 845,
    installCommand: '> install the wallet-portfolio-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/wallet-portfolio-agent',
    usageExample: '> track P&L\n> rebalance\n> optimize taxes',
    detailedDescription: 'Wallet Portfolio Agent provides intelligent portfolio management for crypto wallets. Track real-time profit and loss across all holdings with cost basis calculation and unrealized gains reporting, perform risk-adjusted rebalancing that maintains target allocations while considering volatility and correlation, and schedule transactions for tax optimization including loss harvesting and long-term gain realization.',
  },
  {
    id: 'wallet-portfolio-tracker',
    name: 'wallet-portfolio-tracker',
    author: 'Portfolio Tracker Labs',
    authorHandle: '@portfolio_tracker',
    tag: 'Skill',
    category: 'wallets',
    description: 'Wallet portfolio tracker. Multi-chain balance aggregation, DeFi position monitoring, and historical performance analytics.',
    downloads: 14500,
    stars: 1089,
    installCommand: '> install the wallet-portfolio-tracker skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/wallet-portfolio-tracker',
    usageExample: '> aggregate balances\n> monitor DeFi\n> view history',
    detailedDescription: 'Wallet Portfolio Tracker provides comprehensive portfolio visibility across the crypto ecosystem. Aggregate balances from multiple chains and wallets into a unified dashboard, monitor DeFi positions including liquidity pools, lending positions, and staking rewards with real-time APY tracking, and analyze historical performance with customizable timeframes, benchmark comparisons, and exportable reports.',
  },
  {
    id: 'wallet-skills',
    name: 'wallet-skills',
    author: 'Wallet Skills Foundation',
    authorHandle: '@wallet_skills',
    tag: 'Skill',
    category: 'wallets',
    description: 'General wallet skills toolkit. Address validation, transaction decoding, signature verification, and multi-format key handling.',
    downloads: 9800,
    stars: 734,
    installCommand: '> install the wallet-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/wallet-skills',
    usageExample: '> validate address\n> decode tx\n> verify signature',
    detailedDescription: 'Wallet Skills provides foundational utilities for wallet development and operation. Validate addresses across multiple chain formats and checksums, decode transaction data into human-readable function calls and parameters, verify cryptographic signatures for message authentication and transaction integrity, and handle multiple key formats including raw private keys, seed phrases, and hardware wallet exports.',
  },
  {
    id: 'walletconnect-mcp',
    name: 'walletconnect-mcp',
    author: 'WalletConnect',
    authorHandle: '@walletconnect',
    tag: 'Skill',
    category: 'wallets',
    description: 'WalletConnect MCP server. Protocol-level wallet connections, session management, and chain-agnostic transaction signing for AI agents.',
    downloads: 12300,
    stars: 923,
    installCommand: '> install the walletconnect-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/walletconnect-mcp',
    usageExample: '> establish connection\n> manage session\n> sign transaction',
    detailedDescription: 'WalletConnect MCP provides protocol-level wallet connectivity for AI agents. Establish secure connections to any WalletConnect-compatible wallet with QR code or deep linking, manage sessions with configurable chain support and permission scopes, and execute chain-agnostic transaction signing that automatically handles network switching and gas token management across connected wallets.',
  },
  {
    id: 'walletconnect',
    name: 'walletconnect',
    author: 'WalletConnect',
    authorHandle: '@walletconnect',
    tag: 'Skill',
    category: 'wallets',
    description: 'WalletConnect v2 core integration. Universal wallet connections, encrypted messaging, and cross-platform dApp authentication.',
    downloads: 28900,
    stars: 2145,
    installCommand: '> install the walletconnect skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/walletconnect',
    usageExample: '> connect universal\n> encrypt message\n> authenticate dApp',
    detailedDescription: 'WalletConnect v2 is the universal standard for connecting wallets to dApps. Establish connections across desktop, mobile, and browser environments with a single integration, exchange encrypted messages between dApps and wallets for secure data transfer, and authenticate dApp sessions with cryptographic signatures that verify identity without exposing private keys.',
  },
  {
    id: 'zeal-agent-wallet',
    name: 'zeal-agent-wallet',
    author: 'Zeal Wallet',
    authorHandle: '@zeal_wallet',
    tag: 'Skill',
    category: 'wallets',
    description: 'Zeal AI agent wallet. Proactive security monitoring, smart spending controls, and automated savings strategies for disciplined crypto management.',
    downloads: 6700,
    stars: 512,
    installCommand: '> install the zeal-agent-wallet skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/wallets/zeal-agent-wallet',
    usageExample: '> monitor security\n> set controls\n> auto save',
    detailedDescription: 'Zeal Agent Wallet brings discipline and security to crypto management. Monitor wallet security proactively with real-time threat detection and anomaly alerts, implement smart spending controls with daily limits, merchant whitelists, and transaction cooldown periods, and deploy automated savings strategies that round up purchases and dollar-cost average into target assets on configurable schedules.',
  },
];